"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drillToDashboardHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var drill_1 = require("../../events/drill");
var filterContextSelectors_1 = require("../../store/filterContext/filterContextSelectors");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var converters_1 = require("../../../converters");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var catalogSelectors_1 = require("../../store/catalog/catalogSelectors");
var insightsSelectors_1 = require("../../store/insights/insightsSelectors");
function drillToDashboardHandler(ctx, cmd) {
    var widget, insight, shouldUseDateFilter, dateFilter, _a, isDrillingToSelf, dashboardFilters, _b, dateAttributes, drillIntersectionFilters, resultingFilters;
    var _c;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0: 
            // put start event
            return [4 /*yield*/, effects_1.put(drill_1.drillToDashboardRequested(ctx, cmd.payload.drillDefinition, cmd.payload.drillEvent, cmd.correlationId))];
            case 1:
                // put start event
                _d.sent();
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectAnalyticalWidgetByRef(cmd.payload.drillEvent.widgetRef))];
            case 2:
                widget = _d.sent();
                return [4 /*yield*/, effects_1.select(insightsSelectors_1.selectInsightByRef(widget.insight))];
            case 3:
                insight = _d.sent();
                // if this bombs, widget is not an insight widget and something is seriously wrong
                ts_invariant_1.default(insight);
                shouldUseDateFilter = !!widget.dateDataSet && !isDateFilterDisabled(insight);
                if (!shouldUseDateFilter) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.select(selectDrillingDateFilter, widget)];
            case 4:
                _a = _d.sent();
                return [3 /*break*/, 6];
            case 5:
                _a = undefined;
                _d.label = 6;
            case 6:
                dateFilter = _a;
                isDrillingToSelf = sdk_model_1.areObjRefsEqual(ctx.dashboardRef, cmd.payload.drillDefinition.target);
                if (!isDrillingToSelf) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.select(selectAllAttributeFilters)];
            case 7:
                _b = _d.sent();
                return [3 /*break*/, 10];
            case 8: // if drilling to other, resolve widget filter ignores
            return [4 /*yield*/, effects_1.call(getWidgetAwareAttributeFilters, ctx, widget)];
            case 9:
                _b = _d.sent();
                _d.label = 10;
            case 10:
                dashboardFilters = _b;
                return [4 /*yield*/, effects_1.select(catalogSelectors_1.selectCatalogDateAttributes)];
            case 11:
                dateAttributes = _d.sent();
                drillIntersectionFilters = convertIntersectionToAttributeFilters(cmd.payload.drillEvent.drillContext.intersection, dateAttributes.map(function (dA) { return dA.attribute.ref; }), (_c = ctx.backend.capabilities.supportsElementUris) !== null && _c !== void 0 ? _c : true);
                resultingFilters = compact_1.default(tslib_1.__spread([dateFilter], drillIntersectionFilters, dashboardFilters));
                // put end event
                return [2 /*return*/, drill_1.drillToDashboardResolved(ctx, resultingFilters, cmd.payload.drillDefinition, cmd.payload.drillEvent, cmd.correlationId)];
        }
    });
}
exports.drillToDashboardHandler = drillToDashboardHandler;
function selectDrillingDateFilter(state, widget) {
    var globalDateFilter = filterContextSelectors_1.selectFilterContextDateFilter(state);
    return globalDateFilter
        ? converters_1.dashboardDateFilterToDateFilterByWidget(globalDateFilter, widget)
        : sdk_model_1.newAllTimeFilter(widget.dateDataSet);
}
function selectAllAttributeFilters(state) {
    var filterContextItems = filterContextSelectors_1.selectFilterContextAttributeFilters(state);
    return filterContextItems.map(converters_1.dashboardAttributeFilterToAttributeFilter);
}
function getWidgetAwareAttributeFilters(ctx, widget) {
    var filterContextItems, filters;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilters)];
            case 1:
                filterContextItems = _a.sent();
                filters = filterContextItems.map(converters_1.dashboardAttributeFilterToAttributeFilter);
                return [4 /*yield*/, effects_1.call(getResolvedFiltersForWidget, ctx, widget, filters)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}
function isDateFilterDisabled(insight) {
    var measures = sdk_model_1.insightMeasures(insight);
    return isEmpty_1.default(measures)
        ? false
        : measures.every(function (measure) {
            if (sdk_model_1.isSimpleMeasure(measure)) {
                var filters = sdk_model_1.measureFilters(measure);
                return !!(filters === null || filters === void 0 ? void 0 : filters.some(sdk_model_1.isDateFilter));
            }
            return true;
        });
}
function getResolvedFiltersForWidget(ctx, widget, filters) {
    return ctx.backend.workspace(ctx.workspace).dashboards().getResolvedFiltersForWidget(widget, filters);
}
/**
 *  For correct drill intersection that should be converted into AttributeFilters must be drill intersection:
 *  1. AttributeItem
 *  2. Not a date attribute
 */
function filterIntersection(intersection, dateDataSetsAttributesRefs) {
    var _a, _b;
    var attributeItem = sdk_ui_1.isDrillIntersectionAttributeItem(intersection) ? intersection : undefined;
    var ref = (_b = (_a = attributeItem === null || attributeItem === void 0 ? void 0 : attributeItem.attributeHeader) === null || _a === void 0 ? void 0 : _a.formOf) === null || _b === void 0 ? void 0 : _b.ref;
    return ref ? !dateDataSetsAttributesRefs.some(function (ddsRef) { return sdk_model_1.areObjRefsEqual(ddsRef, ref); }) : false;
}
function convertIntersectionToAttributeFilters(intersection, dateDataSetsAttributesRefs, backendSupportsElementUris) {
    return intersection
        .map(function (i) { return i.header; })
        .filter(function (i) { return filterIntersection(i, dateDataSetsAttributesRefs); })
        .filter(sdk_ui_1.isDrillIntersectionAttributeItem)
        .map(function (h) {
        if (backendSupportsElementUris) {
            return sdk_model_1.newPositiveAttributeFilter(h.attributeHeader.ref, {
                uris: [h.attributeHeaderItem.uri],
            });
        }
        else {
            return sdk_model_1.newPositiveAttributeFilter(h.attributeHeader.ref, {
                uris: [h.attributeHeaderItem.name],
            });
        }
    });
}
//# sourceMappingURL=drillToDashboardHandler.js.map